const ErrorHandler = error => {
  let message = 'Erro ao comunicar com o servidor';
  if (!error) {
    return message;
  }

  if (error.message) message = error.message;

  if (message.includes('cart_expiration')) {
    return 'Cartão expirado';
  }

  if (message.includes('card_number')) {
    return 'Número do cartão ou bandeira inválido';
  }

  if (message.includes('payment_date')) {
    return 'Não foi possível alterar a data de cobrança';
  }

  return message;
};

export default ErrorHandler;
